import Icon from './icon';

// The svgs are embedded, ids uniqified, labeledby added.

const School: React.FC = () => <Icon type="school" />;
const AddressSuggestion: React.FC = () => <Icon type="address-suggestion" />;
const Agent: React.FC = () => <Icon type="agent" />;
const Home: React.FC = () => <Icon type="home" />;
const Inspiration: React.FC = () => <Icon type="inspiration" />;
const Listing: React.FC = () => <Icon type="listing" />;
const PriceEstimation: React.FC = () => <Icon type="price-estimation" />;
const Webhooks: React.FC = () => <Icon type="webhook" />;
const PropertyEnrichment: React.FC = () => <Icon type="property-enrichment" />;
const PropertyPackage: React.FC = () => <Icon type="property-package" />;
const PropertyRadar: React.FC = () => <Icon type="property-radar" />;

export {
  AddressSuggestion,
  Agent,
  Home,
  Inspiration,
  Listing,
  PriceEstimation,
  School,
  Webhooks,
  PropertyEnrichment,
  PropertyPackage,
  PropertyRadar,
};
